const INACTIVITY_KEYS = [
  "inactivity-1",
  "inactivity-2",
  "inactivity-3",
  "inactivity-4",
];
const getRandomInactivityKey = () => {
  return INACTIVITY_KEYS[Math.floor(Math.random() * INACTIVITY_KEYS.length)];
};

export { getRandomInactivityKey };
